<template lang="pug">
f7-page#apply-password-reset-done
  navbar(title="パスワード再設定の反映")

  background
    .label-area
      p.title パスワードを再設定しました。
      p 再設定したパスワードでログインしてください。
</template>

<style lang="scss" scoped>
.label-area {
  padding-left: 16px;
  padding-right: 16px;
}
.title {
  @extend %headline-detail-text;
  margin-top: 48px;
}
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'

export default {
  mixins: [PageTitle],
  title: 'パスワード再設定の反映',
}
</script>
